import { create } from 'zustand';

interface AreaStore {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
}

export const useAreaStore = create<AreaStore>((set) => ({
  searchQuery: '',
  setSearchQuery: (query) => set({ searchQuery: query }),
})); 